TYPE_AUTH